export default "__VITE_ASSET__PmvHBdWO__"